// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"edit-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3.00049 21.0007L7.50024 20.9998L17.5002 10.9998L13.0002 6.5L3.0005 16.4998L3.00049 21.0007Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21.5 7L17 2.5L13 6.5L17.5 10.9998L21.5 7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13.0002 6.5L3.0005 16.4998L3.00049 21.0007L7.50024 20.9998L17.5002 10.9998M13.0002 6.5L17.0002 2.5L21.5002 7L17.5002 10.9998M13.0002 6.5L17.5002 10.9998","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M21 21.0008L14 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-edit-2')
export default class Edit2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-2',
    }
  }
}
